import { z } from 'zod/v4';

export const salesLineSchema = z.object({
  articleId: z.string().default(''),
  description: z.string().min(1, 'sales.validation.descriptionRequired'),
  quantity: z.coerce.number().positive('sales.validation.quantityPositive'),
  unitPriceHt: z.coerce.number().min(0, 'sales.validation.pricePositive'),
  discountPct: z.coerce.number().min(0).max(100).default(0),
  vatRate: z.coerce.number().min(0).max(100).default(19),
  // Metadata from article (not displayed as input, used for UX + benefit calc)
  unit: z.string().default('pcs'),
  purchasePrice: z.coerce.number().min(0).default(0),
});

export type SalesLineFormData = z.infer<typeof salesLineSchema>;

export const salesDocumentSchema = z.object({
  clientId: z.string().default(''),
  representativeId: z.string().default(''),
  carRegistrationNumber: z.string().max(50).default(''),
  docDate: z.string().min(1, 'sales.validation.dateRequired'),
  validityDate: z.string().default(''),
  parentDocId: z.string().default(''),
  notes: z.string().default(''),
  stampApplied: z.boolean().default(false),
  lines: z.array(salesLineSchema).min(1, 'sales.validation.linesRequired'),
  paymentChoice: z.enum(['paid', 'unpaid', 'partial']).default('paid'),
  paymentMethod: z.enum(['cash', 'transfer', 'check', 'card']).default('cash'),
  paidAmount: z.coerce.number().min(0).default(0),
});

export type SalesDocumentFormData = z.infer<typeof salesDocumentSchema>;
